export default class ChannelHelper {
  static getChannelInAlarm(ch: any) {
    // Check if last data is available
    if (
      ch === undefined ||
      ch === null ||
      ch.no === undefined ||
      ch.lastValue === undefined ||
      ch.lastValue.v === undefined
    )
      return false;

    // Temperature check
    if (ch.no === 1 || ch.no === 2 || ch.no === 3 || ch.no === 4) {
      if (
        ch.lastValue.v >= ch.thresholdUp ||
        ch.lastValue.v <= ch.thresholdDown
      )
        return 'WARNING';
    }

    // Input check
    if (ch.no === 7 || ch.no === 8) {
      // Alarm mode
      if (
        ch.mode === 0 &&
        // Value in alarm
        ch.lastValue.v === 1
      )
        return 'ERROR';
      // Counter check
      else if (
        ch.mode === 2 &&
        ch.total !== undefined &&
        ch.counterMax !== undefined &&
        ch.total > ch.counterMax
      )
        return 'WARNING';
    }
    return 'OK';
  }
}
